import get from "lodash/get"
import { urlHelper } from "../util"

const useMainMenuItems = (global, currentLanguage) => {
  // mainMenu returns the model from kontent, contains linkTo
  const mainMenu = global.elements.main_menu.value

  const navigationItems = []

  mainMenu.forEach((topLevel) => {
    const menuComponents = topLevel.elements.menu_items.value
    // should also contain child items for subnav items
    const linkTo = get(topLevel, "elements.link_to.value[0]")

    // shape the linkTo data to pass to mainNav and mobileNav
    navigationItems.push({
      codename: topLevel.system.codename,
      id: topLevel.id,
      label: topLevel.elements.label.value,
      linkTo: linkTo && urlHelper(linkTo),
      columns: get(topLevel, "elements.number_of_columns.value[0].name"),
      components: menuComponents.map((component) => {
        const componentType = component.system.type
        const links = []

        if (componentType === "main_menu_promo") {
          return {
            type: componentType,
            ...component,
          }
        }

        if (componentType === "main_menu_content_type") {
          const componentType = get(
            component,
            "elements.content_type.value[0].codename"
          )

          switch (componentType) {
            case "product_group":
              const productLinks = []
              linkTo.child_items.forEach((productGroup) => {
                links.push({
                  label: productGroup.elements.title.value,
                  url: urlHelper(productGroup),
                  links: productLinks,
                  id: productGroup.id,
                  type: get(productGroup, "system.type"),
                })
              })
              break
            case "service":
              linkTo.child_items.forEach((service) => {
                const subpages = service.child_items
                const subpageLinks = []

                subpages.forEach((subpage) => {
                  subpageLinks.push({
                    label:
                      get(subpage, "elements.meta__nav_title.value") ||
                      get(subpage, "elements.title.value"),
                    url: subpage.resolved_url,
                    id: subpage.id,
                    type: get(subpage, "system.type"),
                  })
                })

                links.push({
                  label: service.elements.title.value,
                  url: urlHelper(service),
                  links: subpageLinks,
                  id: service.id,
                  type: get(service, "system.type"),
                })
              })
              break
            case "industry":
              linkTo.child_items.forEach((industryGroup) => {
                const industries = industryGroup.child_items.filter(
                  (industry) =>
                    get(
                      industry,
                      "elements.meta__hide_from_navigation.value[0].codename"
                    ) !== "yes"
                )

                const industriesLinks = industries.map((industry) => ({
                  label:
                    industry.elements.meta__nav_title.value ||
                    industry.elements.title.value,
                  url: urlHelper(industry),
                  id: get(industry, "system.id") || industry.id,
                  type: get(industry, "system.type"),
                }))

                links.push({
                  label: industryGroup.elements.title.value,
                  url: urlHelper(industryGroup),
                  links: industriesLinks,
                  id: get(industryGroup, "system.id") || industryGroup.id,
                  type: get(industryGroup, "system.type"),
                })
              })
              break
            default:
          }
        } else if (componentType === "main_menu_children") {
          const children = get(
            component,
            "elements.children_of___.value[0].child_items",
            []
          )

          children.forEach((child) => {
            links.push({
              label:
                get(child, "elements.meta__nav_title.value") ||
                get(child, "elements.title.value"),
              url: child.resolved_url,
              id: child.id,
              type: get(child, "system.type"),
            })
          })
        }

        return {
          type: componentType,
          links: links,
        }
      }),
    })
  })

  return navigationItems
}

export { useMainMenuItems }
